document.addEventListener('DOMContentLoaded', function() {
  // Function to add classes based on the presence of '.c-Modal__Image--desktop'
  var modals = document.querySelectorAll('.c-Modal');
  modals.forEach(function(modal) {
    var modalContent = modal.querySelector('.c-Modal__Content');
    if (modal.querySelector('.c-Modal__Image--desktop')) {
      modalContent.classList.add('has-desktop-image');
    }
  });


});
